"use client";

import { useCallback, useEffect, useState } from "react";
import { useAppDispatch } from "../../../../slice/hooks";
import StoreBox from "../store-box";
import CartModal from "./cart-modal";
import { CartOrderDetails } from "./cart-checkout";
import Progress from "./progress";
import styles from "../index.module.scss";

const cx = (...classNames) => classNames.filter(Boolean).join(" ");

import {
  setAccessPoint,
  setAccessPointId,
  setAccessPoints,
  setOrganisation,
} from "../../../../slice/accessOrg-slice";

const CartPage = (props) => {
  const {
    closeModal,
    showProduct,
    activateBackButton,
    modal,
    checkoutState,
    setCheckoutState,
    showProgress,
    setShowProgress,
    navLocation,
    cart,
    organisation,
    accessPoint,
    storePath,
    urlData,
  } = props;

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!urlData) return;
    // Restore organisation context from snapshot
    if (urlData.organisation) {
      dispatch(setOrganisation(urlData.organisation));
    }

    if (urlData.accessPointId) {
      dispatch(setAccessPointId(urlData.accessPointId));
    }

    if (urlData.accessPoint) {
      dispatch(setAccessPoint(urlData.accessPoint));
    }

    if (Array.isArray(urlData.accessPoints)) {
      dispatch(setAccessPoints(urlData.accessPoints));
    }
  }, [urlData]);

  const [isPageMode, setIsPageMode] = useState(modal ? false : true);
  const [publicUser, setPublicUser] = useState(null);
  const [orderDetailsState, setOrderDetailsState] = useState({
    show: false,
    showBillingDetails: false,
    paymentMethod: null,
    paymentGateway: null,
    paymentChargeData: null,
    isLoadingCharge: false,
    cart: null,
  });
  const showOrderDetailsBesideCheckout = orderDetailsState.show;
  const showCheckoutProgress = showProgress && checkoutState !== "summary";

  const handleShowOrderDetails = useCallback((nextState) => {
    if (typeof nextState === "boolean") {
      setOrderDetailsState((prev) => ({
        ...prev,
        show: nextState,
        showBillingDetails: nextState ? prev.showBillingDetails : false,
        cart: nextState ? prev.cart : null,
        paymentMethod: nextState ? prev.paymentMethod : null,
        paymentGateway: nextState ? prev.paymentGateway : null,
        paymentChargeData: nextState ? prev.paymentChargeData : null,
        isLoadingCharge: nextState ? prev.isLoadingCharge : false,
      }));
      return;
    }

    setOrderDetailsState((prev) => ({
      ...prev,
      ...nextState,
      show: nextState?.show ?? true,
    }));
  }, []);

  const handleActivateBackButton = (show, onClickBackButton = null) => {
    activateBackButton?.(show, onClickBackButton);
    setShowProgress(show);
  };

  const handleLocationChange = useCallback(() => {}, []);
  return (
    <StoreBox
      {...props}
      handleLocationChange={handleLocationChange}
      isPageMode={isPageMode}
    >
      <div className={styles.cartContainer}>
        <div
          className={cx(
            styles.cartCase,
            showOrderDetailsBesideCheckout && styles.cartPageCheckoutLayout,
          )}
        >
          <div
            className={
              checkoutState === "summary"
                ? styles.cartPageSummary
                : styles.cartPageMain
            }
          >
            {showCheckoutProgress && (
              <div>
                <Progress
                  checkoutState={checkoutState}
                  setCheckoutState={setCheckoutState}
                  accessPoint={accessPoint}
                  publicUser={publicUser}
                />
              </div>
            )}

              <CartModal
                cart={cart}
                showProduct={showProduct}
                modal={modal}
                closeModal={closeModal}
                accessPoint={accessPoint}
                activateBackButton={handleActivateBackButton}
                checkoutState={checkoutState}
                setCheckoutState={setCheckoutState}
                publicUser={publicUser}
                setPublicUser={setPublicUser}
                isPageMode={isPageMode}
                storePath={storePath}
                organisation={organisation}
                navLocation={navLocation}
                setShowOrderDetails={handleShowOrderDetails}
                setShowProgress={setShowProgress}
              />
            </div>

          {showOrderDetailsBesideCheckout && (
            <aside className={styles.cartPageOrderDetails}>
              <CartOrderDetails
                cart={orderDetailsState.cart || cart}
                accessPoint={accessPoint}
                title="Order Details"
                showBillingDetails={orderDetailsState.showBillingDetails}
                paymentMethod={orderDetailsState.paymentMethod}
                paymentChargeData={orderDetailsState.paymentChargeData}
                isLoadingCharge={orderDetailsState.isLoadingCharge}
                onModifyCart={() => setCheckoutState("cartItems")}
                storePath={storePath}
                navLocation={navLocation}
                showProduct={showProduct}
              />
            </aside>
          )}
        </div>
      </div>
    </StoreBox>
  );
};

export default CartPage;
